// Utilities
import formatSeconds from '../../../utils/date/formatSeconds';

// Styles
import styles from './Countdown.module.css';

/**
 * @function Countdown
 * Countdown timer to next game/session
 *
 * @example
 * return (
 *   <Countdown time={0} />
 * )
 */
function Countdown({ time }: CountdownProps): JSX.Element {
    return <div className={styles.countdown}>{formatSeconds(time)}</div>;
}

/**
 * @interface CountdownProps
 * Describes the properties required for the Countdown component
 *
 * @property {number} time Time remaining on countdown in seconds
 */
export interface CountdownProps {
    time: number;
}

// Exports
export default Countdown;
